export default __webpack_public_path__ + "static/media/jewelry-hot-autumn.2d5a2dcb.png";